
import React, { useState, useContext } from 'react'
import {
	Button,
	Card,
	CardBody,
	Col,
	Form,
	FormGroup,
	Input,
	Label,
	Modal
} from 'reactstrap'
import { useTranslation } from 'react-i18next'
import { SpinnerComponent } from 'react-element-spinner'

import { trigger } from '../../events/customEvents'
import AuctionsService from '../../services/AuctionsService'
import SiteService from '../../services/SiteService'
import { SessionContext } from '../../contexts/SessionProvider'
import { AuctionsContext } from '../../contexts/AuctionsProvider'

const RestartAuctionModal = ({ showRestartAuctionModal = false, auctionId = 0 }) =>
{
	const [isModalBusy, setIsModalBusy] = useState(false)
	const { t } = useTranslation()
	const sessionContext = useContext(SessionContext)
	const [auctionStartTimes, setAuctionStartTimes] = useState({ auctionId: undefined, auctionLocalStartTime: Date.now(), auctionUtcStartTime: new Date().toUTCString() })
	const auctionsContext = useContext(AuctionsContext)

	const handleCancelModal = () =>
	{
		trigger('restartAuctionModalClosed', undefined)
	}

	const convertToUtcDate = (aDate) =>
	{
		return new Date(Date.UTC(aDate.getUTCFullYear(), aDate.getUTCMonth(), aDate.getUTCDate(), aDate.getUTCHours(), aDate.getUTCMinutes(), aDate.getUTCSeconds()))
	}

	const handleAuctionTimeChange = (option) =>
	{
		const { name, value} = option.target

		let currentUtcDate = convertToUtcDate(new Date())
		let selectedUtcDate = convertToUtcDate(new Date(value))

		if ((selectedUtcDate.getUTCDay() === 0 || selectedUtcDate.getUTCDay() === 6) ||
			(selectedUtcDate < currentUtcDate))
		{
			trigger('raiseNotification', { title: 'Invalid Date', message: 'The date cannot be prior to today nor a weekend.', type: 'danger', duration: 5 })
		}
		else
		{
			setAuctionStartTimes((previousAuctionStartTimes) =>
			{
				const currentAuctionStartTimes = { ...previousAuctionStartTimes }
				currentAuctionStartTimes.auctionId = auctionId
				currentAuctionStartTimes.auctionLocalStartTime = value
				currentAuctionStartTimes.auctionUtcStartTime = selectedUtcDate
				return currentAuctionStartTimes
			})
		}
	}

	const handleRestartAuction = () =>
	{
		setIsModalBusy(true)
		AuctionsService
			.restartAuction(auctionStartTimes, sessionContext.loginSession.user.userSession.sessionKey)
			.then(result =>
			{
				setIsModalBusy(false)
				sessionContext.updateSession(result.data.loginSession)

				auctionsContext.setAuction((previousAuction) =>
				{
					let currentAuction = { ...previousAuction }
					currentAuction = result.data.actionResult

					return currentAuction
				})

				trigger('raiseNotification', { title: 'Auction Restarted', message: 'The auction has been restarted.', type: 'success', duration: 5 })
				trigger('restartAuctionModalClosed', undefined)
			})
			.catch((error) =>
			{
				setIsModalBusy(false)
				SiteService.displayApiError(error)
			})
	}

	return (
		<>
			<Modal
				className="modal-dialog-centered"
				size="lg"
				fullscreen="md"
				isOpen={showRestartAuctionModal}
			>
				<SpinnerComponent
					loading={ isModalBusy }
					position="centered"
					color="#3578e5"
					secondaryColor="#f3f3f3"
					backgroundColor="#d3d3d3"
					spinnerType="circle-dots"
				/>
				<div className="modal-body p-0">
					<Card className="bg-secondary border-0 mb-0">
						<CardBody className="px-lg-5 py-lg-5">
							<div className="text-center text-muted mb-4">
								<small>{ t('Modals.RestartAuction.Title') }</small>
							</div>
							<Form role="form">
								<FormGroup className="row">
									<Label
										className="form-control-label"
										htmlFor="auctionLocalStartTime"
										md="3"
									>
										{ t('Modals.RestartAuction.Start_Time') }
									</Label>
									<Col md="9">
										<Input
											type="datetime-local"
											name="auctionLocalStartTime"
											value={ auctionStartTimes.auctionStartTime }
											onChange={ handleAuctionTimeChange }
										/>
									</Col>
								</FormGroup>
								<div className="text-center">
									<Button
										className="my-4"
										color="primary"
										type="button"
										size="sm"
										onClick={() => handleCancelModal()}
									>
										{t('Common.Cancel')}
									</Button>
									<Button
										className="my-4"
										color="primary"
										type="button"
										size="sm"
										onClick={() => handleRestartAuction()}
									>
										{t('Common.Submit')}
									</Button>
								</div>
							</Form>
						</CardBody>
					</Card>
				</div>
			</Modal>
		</>
	)
}

export default RestartAuctionModal
